export default __webpack_public_path__ + "static/media/ec.a4f016ff.jpg";